export default __webpack_public_path__ + "static/twin-b6b2940ddf767336470c5277ab03085a.jpg";